import React, { useContext, useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LinearProgress } from '@mui/material';
import moment from 'moment';
import { toast } from 'react-toastify';
// Components
import CjeActivityModal from './CjeActivityModal';
// API
import { getMdAccountManagementDetails } from '../../../../api/mdProfileApi';

export default function AccountManagementTable({ accountManagement, filterForm }) {
  const [accountDtls, setAccountDtls] = useState({
    loading: false,
    toggle: false,
    title: null,
    details: [],
  });

  console.log('accountManagement', accountManagement);
  const handleViewAccountDetails = async (idValue, monthValue, name) => {
    toast.loading('Processing request please kindly check');
    setAccountDtls({ ...accountDtls, loading: false });
    const request = {
      md_id: filterForm?.doctor_id,
      year: filterForm?.year,
      id: idValue,
      month: moment(monthValue, 'MMM').month() + 1,
    };

    const response = await getMdAccountManagementDetails(request);
    const { code, data } = response.data;

    if (code === '200') {
      toast.dismiss();
      setAccountDtls({ ...accountDtls, loading: false, toggle: true, title: name, details: data });
    }
  };

  const renderParentCell = () => {
    const render = accountManagement?.total?.map((row) => (
      <>
        <TableCell
          colSpan={1}
          align='center'
          sx={{ backgroundColor: '#6b8d3e', fontWeight: 'bold', width: '125px' }}
        >
          {row.month}
        </TableCell>
      </>
    ));

    return render;
  };

  const renderChildCell = () => {
    const render = accountManagement?.total?.map((row) => (
      <>
        <TableCell align='center'>{row.data}</TableCell>
      </>
    ));
    return render;
  };

  const renderTablebody = () => {
    const render = accountManagement?.parents?.map((row) => (
      <TableRow key={row.id}>
        <TableCell component='th' scope='row'>
          {row.name}
        </TableCell>
        {row.details.map((item) => {
          if (item.html_data !== null) {
            return (
              <TableCell
                component='th'
                scope='row'
                onClick={() => handleViewAccountDetails(row.id, item.month, row.name)}
                sx={{ cursor: 'pointer' }}
              >
                <div dangerouslySetInnerHTML={{ __html: item.html_data }} />
              </TableCell>
            );
          }

          return (
            <TableCell component='th' scope='row'>
              {null}
            </TableCell>
          );
        })}
      </TableRow>
    ));

    return render;
  };

  return (
    <>
      {accountManagement?.loading ? (
        <LinearProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label='grouped table'>
            <TableHead>
              {/* First level of headers (grouped) */}
              <TableRow>
                <TableCell
                  rowSpan={2}
                  align='center'
                  sx={{ backgroundColor: '#88a364', fontWeight: 'bold', width: '300px' }}
                >
                  {accountManagement?.section_name}
                </TableCell>
                {renderParentCell()}
              </TableRow>
              {/* Second level of headers (individual columns) */}
              <TableRow>{renderChildCell()}</TableRow>
            </TableHead>
            <TableBody>{renderTablebody()}</TableBody>
          </Table>
        </TableContainer>
      )}
      {accountDtls?.toggle ? (
        <CjeActivityModal accountDtls={accountDtls} setAccountDtls={setAccountDtls} />
      ) : (
        ''
      )}
    </>
  );
}
